import script from "./TechnologyCertification.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnologyCertification.vue?vue&type=script&setup=true&lang=js"

import "./TechnologyCertification.vue?vue&type=style&index=0&id=7b70715e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b70715e"]])

export default __exports__